@if (formService.form().isReservation) {
  <app-loader [text]="'bookingHandler.inStorePayment.loading' | translate">
    <app-in-store-payment/>
  </app-loader>
} @else {
  <app-online-payment [data]="formService.form()" [params]="formService.params"/>
}
